<div mat-dialog-title>
    <h2 class="title">{{data.title}}</h2>
    <button mat-icon-button aria-label="close dialog" tabindex="-1" mat-dialog-close >
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="content" >
    <span class="label">
        {{data.label}}
    </span>

    @for(t of data.body;track $index){
    <p class="text">
        {{t}}
    </p>
    }

</mat-dialog-content>

<mat-dialog-actions>
    <button color="primary" class="button" mat-flat-button mat-dialog-close>OKAY, GOT IT</button>
</mat-dialog-actions>